import { render, staticRenderFns } from "./Preview2D.vue?vue&type=template&id=45df6774&scoped=true"
import script from "./Preview2D.vue?vue&type=script&lang=js"
export * from "./Preview2D.vue?vue&type=script&lang=js"
import style0 from "./Preview2D.vue?vue&type=style&index=0&id=45df6774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df6774",
  null
  
)

export default component.exports